module.exports = __webpack_public_path__ + "static/media/sjcs.f51bd117.png";